import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { parseQueryPageNumber } from "src/utils/helpers/requestApi/parseQueryPageNumber";
import {
  getLastArticles,
  LastArticlesSchema,
} from "src/models/articles/getLastArticles";

export const useLastArticles = (lastArticlesData: LastArticlesSchema) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<LastArticlesSchema>(lastArticlesData);

  const {
    query: { page },
  } = useRouter();

  const currentPage = parseQueryPageNumber(page);

  const changePageHref = (pageNumber: number) => ({
    pathname: pageNumber === 1 ? "/blog/articles" : "/blog/articles/[page]",
    query: {
      ...(pageNumber !== 1 ? { page: `page-${pageNumber}` } : {}),
    },
  });

  useEffect(() => {
    if (data?.paginator?.page !== currentPage) {
      setLoading(true);
      getLastArticles({
        page: currentPage,
      })
        .then((res) => setData(res.data))
        .catch(() => ({}))
        .finally(() => setLoading(false));
    }
  }, [page]);

  return {
    data,
    currentPage,
    changePageHref,
    isLoading,
  };
};
